import { createFileRoute } from '@tanstack/react-router'
import { zodValidator } from '@tanstack/zod-adapter'
import { z } from 'zod'

import Sensors from 'pages/Sensors'

const sensorsSearchSchema = z.object({
  cableSerial: z.coerce.string().optional(),
  id: z.coerce.string().optional(),
})

export const Route = createFileRoute('/_auth/_global/sensors')({
  component: Sensors,
  validateSearch: zodValidator(sensorsSearchSchema),
})
